const en = {
  "Kitchen Display System (KDS)": "Kitchen Display System (KDS)",
};

export default en;
